import type {PaymentOption} from 'src/v2/state/types';

export const getWalletOptionKey = (walletOption: PaymentOption) =>
  walletOption.provider === 'WalletConnect' ||
  walletOption.provider === 'Exchange'
    ? walletOption.key
    : walletOption.provider;
